import React, { createContext, useContext, useEffect } from "react";
import { seo } from "../data/site";

// Filled during build-time prerendering so metadata lands in the static HTML.
export const SeoContext = createContext(null);

export default function Seo({ title, description, path = "", noindex = false, image }) {
  const fullTitle = title || seo.homeTitle;
  const fullDesc = description || seo.homeDescription;
  const canonical = `${seo.baseUrl}${path}`;
  const og = image || seo.ogImage;
  const ssr = useContext(SeoContext);
  if (ssr) Object.assign(ssr, { title: fullTitle, description: fullDesc, canonical: noindex ? null : canonical, noindex, image: og });

  useEffect(() => {
    document.title = fullTitle;
    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", fullDesc);
    setMeta("robots", noindex ? "noindex,nofollow" : "index,follow");
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", fullDesc, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:image", og, "property");
    setMeta("og:locale", "cs_CZ", "property");
    setMeta("twitter:card", "summary_large_image");

    let link = document.querySelector('link[rel="canonical"]');
    if (noindex) {
      if (link) link.remove();
      return;
    }
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [fullTitle, fullDesc, canonical, noindex, og]);

  return null;
}
